export default __webpack_public_path__ + "assets/zislaIcon.801dded2.png";